import { useEffect, useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { parseCap } from '../utils';
import { dangerButtonSx, inputSx, outlinedButtonSx } from './styles';

const smallSx = { minHeight: { xs: 36, sm: 32 }, px: 1.5 };

// One editable cap: a numeric field, Save, and Remove when a value is stored.
export default function CapCell({ label, stored, placeholder, busy, onSave, onRemove }) {
  const [text, setText] = useState(stored === null || stored === undefined ? '' : String(stored));

  useEffect(() => {
    setText(stored === null || stored === undefined ? '' : String(stored));
  }, [stored]);

  const parsed = parseCap(text);
  const hasStored = stored !== null && stored !== undefined;
  const canSave = !busy && parsed !== null && parsed !== stored;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'nowrap' }}>
      <TextField
        size="small"
        value={text}
        placeholder={placeholder || 'No cap'}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && canSave) onSave(parsed);
        }}
        error={text.trim() !== '' && parsed === null}
        inputProps={{ inputMode: 'numeric', 'aria-label': `Cap for ${label}`, style: { width: 64 } }}
        sx={inputSx}
      />
      <Button size="small" variant="outlined" disabled={!canSave} onClick={() => onSave(parsed)} sx={{ ...outlinedButtonSx, ...smallSx }}>
        Save
      </Button>
      {hasStored && (
        <Button size="small" disabled={busy} onClick={onRemove} sx={{ ...dangerButtonSx, ...smallSx }}>
          Remove
        </Button>
      )}
    </Box>
  );
}
